export default {
  user: state => state.user,
  token: state => localStorage.getItem('maishoreca_token'),  
};